import React, { useState, useEffect } from "react";
import Select from "react-select";

const VideoListDropdown = ({ options = [], defaultValues = [], onChange }) => {
  const [items, setItems] = useState([]);
  const [dragIndex, setDragIndex] = useState(null);

  // Convert question_ids -> option objects
  useEffect(() => {
    if (!options.length) return;

    if (defaultValues?.length) {
      const mapped = defaultValues
        .map((id) => options.find((opt) => opt.value === id))
        .filter(Boolean);

      setItems(mapped.length ? mapped : [null]);
    } else {
      setItems([null]);
    }
  }, [defaultValues, options]);

  // notify parent
  useEffect(() => {
    if (!onChange) return;

    const ids = items
      .map((item) => item?.value)
      .filter(Boolean);

    onChange(ids);
  }, [items]);

  // prevent duplicate questions
  const getAvailableOptions = (currentIndex) => {
    const selectedIds = items
      .filter((_, i) => i !== currentIndex)
      .map((i) => i?.value);

    return options.filter((opt) => !selectedIds.includes(opt.value));
  };

  const handleChange = (index, value) => {
    const updated = [...items];
    updated[index] = value;
    setItems(updated);
  };

  const addItem = () => {
    setItems([...items, null]);
  };

  const removeItem = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated.length ? updated : [null]);
  };

  const onDragStart = (index) => {
    setDragIndex(index);
  };

  const onDrop = (index) => {
    if (dragIndex === null) return;

    const updated = [...items];
    const draggedItem = updated[dragIndex];

    updated.splice(dragIndex, 1);
    updated.splice(index, 0, draggedItem);

    setItems(updated);
    setDragIndex(null);
  };

  if (!options.length) {
    return <p className="text-muted mt-2">No Videos Available</p>;
  }

  return (
    <div className="mt-2">
      <ul className="list-unstyled">
        {items.map((item, index) => (
          <li
            key={index}
            draggable
            onDragStart={() => onDragStart(index)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => onDrop(index)}
            className="mb-2"
          >
            <div className="row">
              <div className="col-md-11">
                <Select
                  value={item}
                  onChange={(val) => handleChange(index, val)}
                  options={getAvailableOptions(index)}
                  placeholder="Select Videos"
                  isClearable
                />
              </div>

              <div className="col-md-1">
                <button
                  type="button"
                  className="btn btn-danger"
                  style={{ height: "38px" }}
                  onClick={() => removeItem(index)}
                >
                  -
                </button>
              </div>
            </div>
          </li>
        ))}
      </ul>

      {items.length < options.length && (
        <button
          type="button"
          className="btn btn-primary"
          onClick={addItem}
        >
          +
        </button>
      )}
    </div>
  );
};

export default VideoListDropdown;